import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PbxContext from '../../../context/PbxContext';
import { accessLocalStorage, valuesAnalyze, changeViewForms, changeIpRoutes, readInterfaces, sendRebootSystem } from '../../../services';
import FormRoutesSet from './formIpSetRoutes';
import './RoutesNew.css';

function RoutesNew() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden, toggleIsChangeFormElements } = getItensStateGlobal;
  const history = useHistory();

  const [values, setValues] = useState({});
  const [validate, setValidate] = useState({});
  const [disable, setDisable] = useState(true);
  const [disableInput, setDisableInput] = useState(false);
  const [showIfaces, setShowIfaces] = useState([])

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');
    const getInterfaces = await readInterfaces();
    const interfaces = getInterfaces ? Object.keys(...getInterfaces) : [];
    const filteredInterfaces = interfaces.filter((iface) => !iface.includes('lo'));

    setShowIfaces(filteredInterfaces);
  }, []);

  const changeScreen = (check, name) => {
    changeBorderImputToRedOrNormal(check, name);
    changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const handleChangeDataAnalyze = (name, value) => {
    const { isIP, isMask, isTripleChar } = valuesAnalyze;

    let checkValueIsCharacters = false;
    if (name === 'srdest' || name === 'gw') checkValueIsCharacters = isIP(value);
    if (name === 'mask') checkValueIsCharacters = isMask(value);
    if (name === 'iface') checkValueIsCharacters = isTripleChar(value);
    changeScreen(checkValueIsCharacters, name);
    return checkValueIsCharacters;
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    const itemStatus = handleChangeDataAnalyze(name, value);
    
    setValidate((prevState) => prevState, validate[name] = itemStatus === undefined  ? true : itemStatus);

    setValues((prevState) => prevState, values[name] = value);
    if(Object.keys(validate).length%4 === 0) {
      Object.values(validate).includes(false) ? setDisable(true) : setDisable(false);
    } else {
      setDisable(true)
    }
    return;
  };

  const sendDataChangeIpRoutes = async () => {
    const fetchEndpoints = await changeIpRoutes([values]);
    const result = Object.keys(fetchEndpoints).length > 0 ? true : false;
    if(result) {
      changeVisibityMessages(false, 'success-set-routes');
      setDisableInput(true);
      toggleIsHidden('#button-send-form');
      toggleIsHidden('#alert-create-routes');
      toggleIsHidden('#button-send-reboot');
    };
    return;
  };

  const sendRebootSystemPage = async () => {
    await sendRebootSystem();
    history.push('/home');
  };

  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  return (
    <div className="routes-new-container">
      <div className="routes-new-header">
        <div className="routes-new-title-wrapper">
          <svg className="routes-new-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
          </svg>
          <div>
            <h1 className="routes-new-title">Adicionar Rotas</h1>
            <p className="routes-new-subtitle">Configure novas rotas de rede no sistema</p>
          </div>
        </div>
      </div>

      <div className="alerts-section">
        <div id="alert-create-routes" name="alert-create-routes" className="alert-message alert-danger is-hidden">
          <div className="alert-header">
            <span>Atenção!</span>
            <button className="alert-close" aria-label="delete" onClick={ () => {
              toggleIsHidden('#alert-create-routes');
              toggleIsHidden('#button-send-form');
              toggleIsHidden('#button-send-reboot');
              setDisableInput(false);
            }}>×</button>
          </div>
          <div className="alert-body">
            Para as configurações serem aplicadas será efetuado o <strong>reboot</strong> do sistema.
            <br />
            Click no botão <strong>Aplicar</strong> ou feche essa mensagem para reiniciar mais tarde.
          </div>
        </div>
      </div>

      <div name="success-set-routes" className="route-form-section">
        <FormRoutesSet iface={ showIfaces } handleChangeValues={ handleChangeValues } disableInput={ disableInput } />
      </div>

      <div className="route-actions">
        <div id="button-send-form" name="button-send-form">
          <button className="btn-configure-route" type="submit" disabled={ disable } onClick={ () => sendDataChangeIpRoutes() }>
            <svg className="btn-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Configurar Rota
          </button>
        </div>

        <div id="button-send-reboot" name="button-send-reboot" className="is-hidden">
          <button className="btn-apply-reboot" type="submit" onClick={ () => sendRebootSystemPage() }>
            <svg className="btn-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
            <strong>Aplicar e Reiniciar</strong>
          </button>
        </div>
      </div>
    </div>
  );
}

export default RoutesNew;
